import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { Typography } from '@mui/material'

import { getEntraIdRolesAsync } from '../../api/entraIdRolesApi'
import {
  EntraIdRoleRequestDto,
  EntraIdRoleResponseDto,
} from '../../api/kmsapiclient'
import Spinner from '../../components/common/Spinner'
import {
  apiCallError,
  beginApiCall,
} from '../../redux/actions/apiStatusActions'
import { getEntraIdRolesSuccess } from '../../redux/actions/entraIdRolesActions'
import { useAppDispatch } from '../../redux/configureStore'
import { IRootState } from '../../redux/reducers'
import {
  EntraIdRolesState,
  IdentityState,
  UserPermissionsState,
} from '../../redux/reducers/initialState'

import { EntraIdRolesListView } from './entraIdRolesListView'

export const EntraIdRolesPage = () => {
  const loading: boolean = useSelector(
    (state: IRootState) => state.apiCallsInProgress > 0,
  )
  const identity: IdentityState | null = useSelector(
    (state: IRootState) => state.identity,
  )
  const userPermissionsState: UserPermissionsState | null = useSelector(
    (state: IRootState) => state.userPermissions,
  )
  const entraIdRolesState: EntraIdRolesState = useSelector(
    (state: IRootState) => state.entraIdRoles,
  )

  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const [entraIdRoles, setEntraIdRoles] = useState<EntraIdRoleRequestDto[]>([])
  useEffect(() => {
    if (
      entraIdRolesState?.entraIdRoles &&
      entraIdRolesState.entraIdRoles.length > 0
    ) {
      setEntraIdRoles([...entraIdRolesState.entraIdRoles])
    }
  }, [entraIdRolesState, entraIdRolesState.entraIdRoles])

  useEffect(() => {
    if (
      identity != null &&
      userPermissionsState &&
      userPermissionsState.hasEntraIDRolesAccess
    ) {
      dispatch(fetchEntraIdRoles)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [identity, userPermissionsState])

  /**
   * Function to retrieve the Entra ID Roles
   */
  const fetchEntraIdRoles = async () => {
    dispatch(beginApiCall())
    try {
      const entraIdRoles: EntraIdRoleResponseDto[] =
        await getEntraIdRolesAsync()
      dispatch(getEntraIdRolesSuccess({ entraIdRoles: entraIdRoles }))
    } catch (error) {
      dispatch(apiCallError())
      throw error
    }
  }

  const renderEntraIdRoles = (): React.JSX.Element => {
    return (
      <div className="page-content">
        <Typography variant="subtitle1">
          <div className="responsive-font">{t('entraid.instructions')}</div>
        </Typography>
        <EntraIdRolesListView entraIdRoles={entraIdRoles} />
      </div>
    )
  }

  return (
    <div className="container">
      <h3 className="page-header">{t('manage.entra_id_roles')}</h3>
      {loading ? <Spinner /> : <>{renderEntraIdRoles()}</>}
    </div>
  )
}
